"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var NavBar_1 = require("stremio/components/NavBar");
var GamepadNavigation_1 = require("stremio/services/GamepadNavigation");
var activeProfile_1 = require("stremio/plus/activeProfile");
var kids_1 = require("stremio/plus/kids");
var MainNavBars_less_1 = __importDefault(require("./MainNavBars.less"));
var TABS = [
    { id: 'board', label: 'Board', icon: 'home', href: '/' },
    { id: 'discover', label: 'Discover', icon: 'discover', href: '/discover' },
    { id: 'library', label: 'Library', icon: 'library', href: '/library' },
    { id: 'calendar', label: 'Calendar', icon: 'calendar', href: '/calendar' },
    { id: 'addons', label: 'ADDONS', icon: 'addons', href: '/addons' },
    { id: 'settings', label: 'SETTINGS', icon: 'settings', href: '/settings' },
];
var MainNavBars = (0, react_1.memo)(function (_a) {
    var className = _a.className, route = _a.route, query = _a.query, children = _a.children;
    var navRef = react_1.default.useRef(null);
    var contentRef = react_1.default.useRef(null);
    var tabs = react_1.default.useMemo(function () {
        var _a;
        return ((_a = (0, activeProfile_1.getActiveProfile)()) === null || _a === void 0 ? void 0 : _a.isKids) ? TABS.filter(function (_a) {
            var href = _a.href;
            return !kids_1.KIDS_BLOCKED_ROUTES.includes(href);
        }) : TABS;
    }, []);
    var navRoute = route === 'continue_watching' ? 'library' : (route !== null && route !== void 0 ? route : '');
    (0, GamepadNavigation_1.useContentGamepadNavigation)(contentRef, navRoute);
    (0, GamepadNavigation_1.useVerticalNavGamepadNavigation)(navRef, navRoute);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, MainNavBars_less_1.default['main-nav-bars-container']) },
        react_1.default.createElement(NavBar_1.HorizontalNavBar, { className: MainNavBars_less_1.default['horizontal-nav-bar'], route: route, query: query, backButton: false, searchBar: true, fullscreenButton: true, navMenu: true }),
        react_1.default.createElement(NavBar_1.VerticalNavBar, { ref: navRef, className: MainNavBars_less_1.default['vertical-nav-bar'], selected: route, tabs: tabs }),
        react_1.default.createElement("div", { ref: contentRef, className: MainNavBars_less_1.default['nav-content-container'] }, children)));
});
exports.default = MainNavBars;
